import { ProductDatingUponReceiptIssueTypeInternational } from '../../../../enums';

export interface IProductDatingSubtypeInt {
    issueType: ProductDatingUponReceiptIssueTypeInternational;
    declinedWithin24Hours?: boolean;
    batchExpiryMeetsMinShipPolicy?: boolean;
}
